import type { XAxisPlotLinesLabelOptions, XAxisPlotLinesOptions } from "highcharts";

export type PlotlineProps = {
  isPlotlineVisible: boolean;
  verticalLineTime: number;
  verticalLineLabel: string;
  timePlotlineConfig: TimePlotlineConfig;
};

export type TimePlotlineConfig = {
  lineColor: string;
  backgroundColor?: string;
  id: string;
  className: string;
  label: XAxisPlotLinesLabelOptions;
};

export const nowPlotlineConfig: TimePlotlineConfig = {
  lineColor: "green",
  backgroundColor: "rgba(0, 255, 0, 0.05)",
  id: "vertical-line-now-line",
  className: "now-line-label",
  label: { verticalAlign: "top", y: -2 },
};

export const dispalyTimePlotlineConfig: TimePlotlineConfig = {
  lineColor: "blue",
  backgroundColor: "rgba(0, 0, 255, 0.05)",
  id: "vertical-line-display-time-line",
  className: "display-time-line-label",
  label: { verticalAlign: "bottom", y: 10 },
};

/**
 * Toggles the visibility of a time plotline.
 *
 * The plotline is considered visible by default when its stored value is `null`/`undefined`,
 * so toggling from that default state must flip to `false`, not re-affirm `true`.
 */
export const toggleTimePlotlineVisibility = (current: boolean | null | undefined): boolean => !(current ?? true);

export const createHighchartsPlotLines = (plotlineProps: PlotlineProps): XAxisPlotLinesOptions[] => {
  if (!plotlineProps.isPlotlineVisible || !plotlineProps.verticalLineTime) {
    return [];
  }
  const { id, lineColor, backgroundColor, className } = plotlineProps.timePlotlineConfig;

  const xAxisPlotline: XAxisPlotLinesOptions[] = [
    {
      id: id,
      className: id,
      color: lineColor,
      width: 2,
      value: plotlineProps.verticalLineTime,
      dashStyle: "Dash",
      zIndex: 3,
      label: {
        // @ts-ignore className should exist in label props for Options type
        className: `${id}-label`,
        text: plotlineProps.verticalLineLabel,
        align: "left",
        rotation: 0,
        x: -1,
        style: {
          fontSize: "10px",
          color: lineColor,
          fontWeight: "bold",
        },
        ...plotlineProps.timePlotlineConfig.label,
      },
    },
  ];

  if (backgroundColor) {
    xAxisPlotline.push({
      id: `${id}-bg`,
      className: className,
      color: backgroundColor,
      width: 20,
      value: plotlineProps.verticalLineTime,
      zIndex: 3,
    });
  }
  return xAxisPlotline;
};
